<template>
  <!-- 配方头部 -->
  <div class="containerPaddingBlock" style="margin: 15px 0">
    <img :src="formulaImg" class="formulaImg" />
    <h3 class="fb boxPadding mb20 pRelative disInB">
      产品名称：<span>{{details.productName}}</span>
      <!-- <span class="tag">{{formulaType}}</span> -->
      <a-tag color="green" style="margin-left: 10px;">
        {{formulaType}}
      </a-tag>
      <a-button class="pushBtn" type='primary' @click="pushEbsFunction" :disabled='ablePush'>推送EBS</a-button>
    </h3>
    <div class="boxPadding">
      <span class="mr40">营养师：{{details.staffName}}</span>
      <span class="mr40">生成时间：{{details.createTime}}</span>
      <span class="mr40">是否推送：{{isPushEbs}}</span>
      <span class="mr40">推送时间：{{details.pushTime}}</span>
      <span class="mr40">推送工厂：{{details.ebsPushFactoryName}}</span>
    </div>
    <div class="priceBox">
      <!-- <a-button class="pushBtn" type='primary'>推送EBS</a-button> -->
      <div class="priceBoxTextStyle">
        <p>产品成本(元/吨)</p>
        <h3>￥{{details.price}}</h3>
      </div>
    </div>
    <push-EBS ref="pushEbs" :visible="pushEbsVisible" @close='closeEBS' :productIds='productIds' :reasonList='reasonList' :version='version' :selfFactoryId='selfFactoryId'/>
  </div>
</template>

<script>
import formulaImg from '@/assets/images/formulaImg.png'
import PushEBS from './PushEBS.vue'
export default {
  props: ['details','reasonList','productIds'],
  components: {PushEBS},
  data(){
    return{
      formulaImg,
      pushEbsVisible: false,
      version: 0
    }
  },
  computed: {
    isPushEbs(){
      return this.details.isPushEbs === 1 ? '已推送' : '未推送'
    },
    formulaType(){
      let str = ''
      let {formulaType} = this.details || {}
      if(formulaType === 1) str = '配合饲料'
      if(formulaType === 2) str = '混合日粮'
      if(formulaType === 3) str = 'TMR'
      if(formulaType === 4) str = '定制料'
      return str
    },
    ablePush(){
      return this.details.isActivate == 0 || this.details.isPushEbs === 1
    },
    selfFactoryId(){
      return this.details.factoryId
    }
  },
  methods: {
    pushEbsFunction(){
      this.version = this.details.version
      this.getLinkFactory()
    },
    getLinkFactory(){
      let params = {
        factoryId: window.localStorage.getItem('factoryId')
      }
      this.$http.get('/iot-factory/factorysublink/subFactoryList',{params}).then(res => {
        let {data,success} = res || {}
        if(success) {
          if(data.length > 0){
            this.pushEbsVisible = true
          }else{
            if(this.version == 1){
              this.$confirm({
                title: '推送EBS',
                content: '确认将该产品推送到EBS吗?',
                okText: '继续',
                cancelText: '取消',
                onOk: async () =>{
                  this.closeEBS({type: true,ebsPushFactoryId: window.localStorage.getItem('factoryId')})
                },
                onCancel(){},
              })
            }else{
              this.pushEbsVisible = true
            }
          }
        }
      })
    },
    async closeEBS({type,ebsPushFactoryId}){
      if(type) {
        const hide = this.$message.loading('推送EBS中...', 0)
        let params = {
            ebsPushFactoryId,
            ids: this.productIds.join(',')
          }
        this.$http.post('/nhf-app/formulaproduct/batchPushEbsProductIds',params).then(res => {
          let {success,data,msg} = res || {}
          if(success){
            if(data && data.length > 0) {
              let msg = data.map((el) => {
                return <p>{el}</p>
              })
              this.$warning({
                title: '请注意',
                content: msg,
                width: 600,
                onOk: () => {
                  this.$emit('refresh');
                }
              });
            }else{
              this.$emit('refresh');
            }
          }else{
            this.$message.warning(msg)
          }
          
        }).finally(() => {
          setTimeout(hide, 0)
        })
        
      }
      this.pushEbsVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.fb{
  font-weight: bold;
}
.boxPadding{
  padding-left: 40px;
}
.mr40{
  margin-right: 40px;
}
.mb20{
  margin-bottom: 20px;
}
.pRelative{
  position: relative;
}
.disInB{
  display: inline-block;
}
.tag{
  position: absolute;
  right: -90px;
  top: 0;
  font-weight: normal;
  background: #1990ff;
  color: #fff;
  padding: 3px 15px;
  border-radius: 15px;
  font-size: 12px;
}
</style>